import { ChartOptions } from 'chart.js'
import { getCssRgbValue } from 'shared/utils/get-css-rgb-value'

export const getEmailStatisticsChartOptions = (showGrid: boolean): ChartOptions<'bar'> => ({
  maintainAspectRatio: false,
  responsive: true,
  font: { family: 'Averta' },
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      display: showGrid,
      border: { dash: [12, 12], display: false },
      grid: {
        color: function (context) {
          if (context.tick.value === 0) {
            return 'rgba(0, 0, 0, 0)'
          }
          return getCssRgbValue('--text-secondary', 0.3)
        },
        drawTicks: false,
      },
      ticks: {
        color: getCssRgbValue('--text-primary'),
      },
    },
    x: { grid: { display: false }, ticks: { color: getCssRgbValue('--text-primary') } },
  },
})
